export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDG3epPZlIC-bDzKBV_4cUyqJwm5hSiATs",
  authDomain: "hyperion-mobile.firebaseapp.com",
  databaseURL: "https://hyperion-mobile.firebaseio.com",
  projectId: "hyperion-mobile",
  storageBucket: "hyperion-mobile.appspot.com",
  messagingSenderId: "972431393049",
  appId: "1:972431393049:web:07035ffacf8e77da634588",
};

export const VAPID_KEY =
  "BK7WBfTvKj3ryFidbSHE6-6HugjxIf0p7YG0nHZ4mk7cwhNqQW-T5VDkp1b4AQPaD_uI6vWjCLvBtO_QpjrJ9FA";
